import { AlertTriangle, Home, RefreshCw } from 'lucide-react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import { PublicLayout } from '@/components/layouts'

function getErrorDetails(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return {
      title: `${error.status} ${error.statusText || '页面异常'}`,
      description:
        typeof error.data === 'string'
          ? error.data
          : '页面或接口在处理请求时发生异常。',
    }
  }

  if (error instanceof Error) {
    return {
      title: '页面发生异常',
      description: error.message || '组件渲染时发生未知错误。',
    }
  }

  return {
    title: '页面发生异常',
    description: '组件渲染时发生未知错误。',
  }
}

export default function RouteErrorPage() {
  const error = useRouteError()
  const { title, description } = getErrorDetails(error)

  return (
    <PublicLayout>
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(239,68,68,0.12),_transparent_34%),radial-gradient(circle_at_bottom_right,_rgba(99,102,241,0.14),_transparent_38%)]" />
        <div className="absolute inset-0 opacity-35 [background-image:linear-gradient(rgba(148,163,184,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.1)_1px,transparent_1px)] [background-size:28px_28px]" />
        <div className="relative flex min-h-[calc(100vh-64px-76px)] items-center justify-center px-4 py-16">
          <div className="w-full max-w-3xl rounded-[2rem] border border-[#edf0f8]/70 bg-[#f8f8fc]/84 p-8 shadow-[0_32px_80px_rgba(15,23,42,0.16)] backdrop-blur-2xl dark:border-neutral-800/80 dark:bg-[#1a1b1d]/82 md:p-10">
            <div className="flex flex-col items-center text-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-[1.4rem] bg-rose-100 text-rose-600 dark:bg-rose-500/15 dark:text-rose-300">
                <AlertTriangle className="h-8 w-8" />
              </div>
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.28em] text-rose-500">
                Route Error
              </p>
              <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">
                {title}
              </h1>
              <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-600 dark:text-slate-400">
                {description}
              </p>

              <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="inline-flex items-center gap-2 rounded-[1rem] bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-indigo-500"
                >
                  <RefreshCw className="h-4 w-4" />
                  刷新页面
                </button>
                <a
                  href="/"
                  className="inline-flex items-center gap-2 rounded-[1rem] border border-[#dfe3ef] bg-[#f8f8fc]/84 px-4 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-[#eef1f8] dark:border-neutral-700 dark:bg-[#1a1b1d]/74 dark:text-slate-300 dark:hover:bg-[#222427]"
                >
                  <Home className="h-4 w-4" />
                  返回首页
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  )
}
